// const environment = require("../ENV");

const local = {
  ENV: "local",
  // API: 'http://100.69.4.80:9002/',
  // API: 'http://100.69.165.8:9002/',
  // API: 'http://100.69.4.152/',
  // API: 'http://cloud-admin.dev.cmft.com/api',
  API: "http://cloud-admin.sit.cmft.com/api",
  // API: 'https://cloud.uat.cmft.com/api',
  publicPath: "./"
};

const development = {
  ENV: "development",
  API: "https://cloud.dev.cmft.com/api",
  publicPath: "./"
};
const testing = {
  ENV: "testing",
  API: "http://100.69.4.80:9002/",
  publicPath: "./"
};

const sit = {
  ENV: "sit",
  // API: 'http://100.69.165.8:9002/',
  API: "http://cloud.sit.cmft.com/api",
  publicPath: "./"
};

const uat = {
  ENV: "development",
  API: "https://cloud.uat.cmft.com/api",
  publicPath: "./"
};

const production = {
  ENV: "production",
  API: "https://cloud.cmft.com/api",
  publicPath: "./"
};

const APP_Test = {
  ENV: "APP",
  API: "",
  publicPath: "./"
};

const APP_Prod = {
  ENV: "APP",
  API: "",
  publicPath: "./"
};

module.exports = (function() {
  // if (environment === "development") {
  //   return development;
  // } else if (environment === "local") {
  //   return local;
  // } else if (environment === "testing") {
  //   return testing;
  // } else if (environment === "sit") {
  //   return sit;
  // } else if (environment === "uat") {
  //   return uat;
  // } else if (environment === "production") {
  //   return production;
  // } else if (environment === "APP_Test") {
  //   return APP_Test;
  // } else if (environment === "APP_Prod") {
  //   return APP_Prod;
  // }

  if (window.location.href.includes(".sit.")) {
    return local;
  } else {
    return production;
  }
})();



// WEBPACK FOOTER //
// ./src/config/APIs.js